import React from "react";
import loadable from "@loadable/component";
import clsx from "clsx";

import styles from "./MenuItem.styles";

const ReactLink = loadable(() => import("@micado-digital/react-link/ReactLink"));
const ReactSVGIcon = loadable(() => import("@micado-digital/react-svg-icon/ReactSVGIcon"));
const Typography = loadable(() => import("@micado-digital/react-ui/components/Typography"));

const MenuItem = ({ item, level, onClick, selected }) => {
	const css = styles();
	const { link, target, title } = item;
	let variant = "";

	switch (level) {
		case 1:
			variant = "label-medium";
			break;
		case 2:
			variant = "label-medium";
			break;
		default:
			variant = "label-medium";
	}

	return (
		<ReactLink
			className={clsx(
				css.menuItem,
				"mco-view-component-header-desktop-menu-item-level" + level,
				{
					"mco-view-component-header-desktop-menu-item--selected": selected
				}
			)}
			onClick={e => onClick && onClick(e, item)}
			target={target}
			to={link}
		>
			<Typography dangerouslySetInnerHTML={{ __html: title }} variant={variant} />
			{item?.items?.length > 0 && level === 1 && (
				<ReactSVGIcon size={16} src="/img/icons/chevron-down.svg" />
			)}
		</ReactLink>
	);
};

export default MenuItem;
